import { MeasurementResultsEvent } from "./measurements/MeasurementResultsEvent";

export class GenericGameStateEvent extends MeasurementResultsEvent {
    public gamestate: string;
    public sequence: number;

    constructor(referrer: string) {
        super(referrer);
    }

    public getVars(): any {
        let vars: any = super.getVars();

        vars.gamestate = this.gamestate;
        vars.sequence = this.sequence;

        return vars;
    }
}
